import { defineMessages } from 'react-intl';

export default defineMessages({
  migrationText:
    'Deposit and borrow of {token} is disabled due to the ongoing migration. You can still repay and withdraw to migrate your token {here}',
  here: 'here',
  freezedText: 'Deposit and borrow of {token} is disabled',
});
